import RpcClass from "../../../../../../server/RpcClass.js";


import RpcNotFoundException from "../../../../../../server/com/silkplm/engine/rpc/exceptions/RpcNotFoundException.js";

let locale;
if(typeof window !== "undefined") {
    locale = window?.navigator?.userLanguage || window?.navigator?.language || Intl.DateTimeFormat().resolvedOptions().locale;
} else {
    locale= RpcClass.locale = Intl.DateTimeFormat().resolvedOptions().locale;
}

const FULL_CLASS = 'com.silkplm.rpc.plm.services.CompanyConfigurationService';

import LocalDate from "../../../../../../server/LocalDate.js";
import LocalDateTime from "../../../../../../server/LocalDateTime.js";
import LocalTime from "../../../../../../server/LocalTime.js";



class CompanyConfigurationService extends RpcClass{

    /**
     *  @class CompanyConfigurationService
     *  @alias module:src/server/com/silkplm/rpc/plm/services/CompanyConfigurationService.CompanyConfigurationService
     *  
     * */
    constructor(){
        super();


    }






    /** 
     * @async
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/model/users/CompanyConfigurationFunctionalFlag.CompanyConfigurationFunctionalFlag>}
     */
     findFunctionalFlagsForOrganization() {
            return RpcClass.rpcCall('/rpc/plm/services/company-configuration-service/find-functional-flags-for-organization', []);
    }
    /** 
     * @async
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/model/plm/OrganizationFormsSettings.OrganizationFormsSettings>}
     */
     findOnlyFormAndFieldsSettings() {
            return RpcClass.rpcCall('/rpc/plm/services/company-configuration-service/find-only-form-and-fields-settings', []);
    }
    /** 
     * @async
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<Object.<string, module:src/server/com/silkplm/model/plm/CompanyConfigurationFormField.CompanyConfigurationFormField[]>>}
     */
     findRequiredFieldsForIntegration() {
            return RpcClass.rpcCall('/rpc/plm/services/company-configuration-service/find-required-fields-for-integration', []);
    }
    /** 
     * @async
     * @param formId {number} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/model/plm/CompanyConfigurationForm.CompanyConfigurationForm>}
     */
     findSettingsForForm(formId) {
            return RpcClass.rpcCall('/rpc/plm/services/company-configuration-service/find-settings-for-form', [formId]);
    }
    /** 
     * @async
     * @param formId {number} 
     * @param fieldName {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/model/plm/CompanyConfigurationFormField.CompanyConfigurationFormField>}
     */
     findSettingsForFormField(formId, fieldName) {
            return RpcClass.rpcCall('/rpc/plm/services/company-configuration-service/find-settings-for-form-field', [formId, fieldName]);
    }
    /** 
     * @async
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/model/plm/OrganizationFormsSettings.OrganizationFormsSettings>}
     */
     findSettingsForOrganizationFieldsAndForms() {
            return RpcClass.rpcCall('/rpc/plm/services/company-configuration-service/find-settings-for-organization-fields-and-forms', []);
    }
    /** 
     * @async
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/model/plm/dictionaries/Currency.Currency>}
     */
     findSystemCurrency() {
            return RpcClass.rpcCall('/rpc/plm/services/company-configuration-service/find-system-currency', []);
    }
    /** 
     * @async
     * @param sampleId {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<boolean>}
     */
     findVisibleForSizeForProductInSeason(sampleId) {
            return RpcClass.rpcCall('/rpc/plm/services/company-configuration-service/find-visible-for-size-for-product-in-season', [sampleId]);
    }
    /** 
     * @async
     * @param sampleId {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<boolean>}
     */
     findVisibleForSizeRangeForProductInSeason(sampleId) {
            return RpcClass.rpcCall('/rpc/plm/services/company-configuration-service/find-visible-for-size-range-for-product-in-season', [sampleId]);
    }
    /** 
     * @async
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<*>}
     */
     updateCompanyConfigurationFormAndFields() {
            return RpcClass.rpcCall('/rpc/plm/services/company-configuration-service/update-company-configuration-form-and-fields', []);
    }


    /** @returns {string} */
    getRemoteClass(){
        return FULL_CLASS;
    }
}



let metadata = {};

metadata.__type__ = 'com.silkplm.rpc.plm.services.CompanyConfigurationService';
metadata.__type_short__ = 'CompanyConfigurationService';
CompanyConfigurationService.prototype.__metadata__ = metadata;

CompanyConfigurationService.prototype.__cls__ = FULL_CLASS;

/** @module src/server/com/silkplm/rpc/plm/services/CompanyConfigurationService */
export default CompanyConfigurationService

export { CompanyConfigurationService }
